import LandingPage from "@/components/utopie/pages/LandingPage";
import institucionalRoutes from "@/pages/institucional/routes";
import Dashboard from "../../components/utopie/pages/Dashboard";
// import ChatbotMainPage from "@/components/botpie-assistant/ChatbotMainPage";
import ChatbotPlanification from "@/components/botpie-assistant/ChatbotPlanification";
import ChatbotMaterials from "@/components/botpie-assistant/ChatbotMaterials";
// import EurekaTable from "@/components/redpie/miscellaneous/EurekaTable";
import ChatbotEureka from "@/components/botpie-assistant/ChatbotEureka";
import ChatbotTestCorrection from "@/components/botpie-assistant/ChatbotTestCorrection";
import ChatbotIndividualDocuments from "@/components/botpie-assistant/ChatbotIndividualDocuments";
import IndividualDocumentsDemo from "@/components/botpie-assistant/IndividualDocumentsDemo";
import PlanificationDemo from "@/components/botpie-assistant/PlanificationDemo";
import EurekaDemo from "@/components/botpie-assistant/EurekaDemo";
import MaterialsDemo from "@/components/botpie-assistant/MaterialsDemo";
import MaterialesClaseDemo from "@/components/botpie-assistant/MaterialesClaseDemo";
import ChatbotMaterialesClase from "@/components/botpie-assistant/ChatbotMaterialesClase";
import TestCorrectionDemo from "@/components/botpie-assistant/TestCorrectionDemo";
import PieDemo from "@/components/botpie-assistant/PieDemo";
import ProductDetails from "@/components/utopie/pages/ProductDetails";
import Fudei from "../../components/tests/Fudei";
import InvitationRegister from "../../components/utopie/miscellaneous/InvitationRegister";
import Marketplace from "../../components/utopie/pages/Marketplace";
import Media from "../../components/utopie/pages/Media";
import NewPlanification from "../../components/tests/NewPlanification";
import PostComponent from "../../components/utopie/miscellaneous/PostComponent";
import ProfileNotifications from "../../components/utopie/pages/ProfileNotifications";
import ProfileMissions from "../../components/utopie/pages/ProfileMissions";
import ProfilePoints from "../../components/utopie/pages/ProfilePoints";
import PersonalData from "../../components/redpie/pages/PersonalData";
import ProfileTests from "../../components/utopie/pages/ProfileTests";
import ProfileDelete from "../../components/utopie/pages/ProfileDelete";
import AddOrChangePasswordAdmin from "../../components/utopie/miscellaneous/AddOrChangePasswordAdmin";
import ServicesUsageAdmin from "../../components/utopie/miscellaneous/ServicesUsageAdmin";
import MissionCreateAdmin from "../../components/utopie/miscellaneous/MissionCreateAdmin";
import GoldenTicketsAdmin from "../../components/utopie/miscellaneous/GoldenTicketsAdmin";
import MissionCompleteAdmin from "../../components/utopie/miscellaneous/MissionCompleteAdmin";
import BuyProduct from "../../components/utopie/pages/BuyProduct";
import Router from "vue-router";
import Vue from "vue";

Vue.use(Router);

export default new Router({
  base: "/utopie/",
  routes: [
    // `landing`: el layout esconde su hero y sus burbujas (ver Default.vue).
    { path: "/", component: LandingPage, name: "home", meta: { landing: true } },
    {
      path: "/social",
      component: Dashboard,
      name: "social",
    },
    {
      path: "/planification",
      // component: ChatbotMainPage,
      component: ChatbotPlanification,
      name: "planification",
    },
    {
      path: "/class-materials",
      component: ChatbotMaterialesClase,
      name: "class-materials",
    },
    {
      path: "/materials",
      component: ChatbotMaterials,
      name: "materials",
    },
    {
      path: "/eureka",
      component: ChatbotEureka,
      name: "eureka",
    },
    {
      // El corrector real, con sesión. Es una página propia como la de cada
      // servicio: el chatbot con el saldo de usos y sus opciones, con
      // CorregirTestWorkspace montado como paso. Antes era una sección dentro
      // de la LandingPage (`autoOpenCorregirTest`), que la dejaba sin menú.
      path: "/corregir-test",
      component: ChatbotTestCorrection,
      name: "corregir-test",
    },
    {
      // Alias del nombre viejo: quedó publicado en enlaces que no controlamos.
      path: "/test-correction",
      redirect: { name: "corregir-test" },
      name: "test-correction",
    },
    {
      path: "/individual-documents",
      component: ChatbotIndividualDocuments,
      name: "individual-documents",
    },
    {
      // Logged-out "try it free" interactive demo (no auth, nothing persisted).
      path: "/individual-documents-demo",
      component: IndividualDocumentsDemo,
      name: "individual-documents-demo",
    },
    {
      // Logged-out demo for Planifications: log in to try the real version, or
      // "know more" (the service description).
      path: "/planification-demo",
      component: PlanificationDemo,
      name: "planification-demo",
    },
    {
      path: "/class-materials-demo",
      component: MaterialesClaseDemo,
      name: "class-materials-demo",
    },
    {
      // Logged-out demo for Eureka: log in to try the real version, or
      // "know more" (the test description).
      path: "/eureka-demo",
      component: EurekaDemo,
      name: "eureka-demo",
    },
    {
      // Logged-out demo for Pruebas Informales: log in to try the real version,
      // or "know more" (the service description).
      path: "/materials-demo",
      component: MaterialsDemo,
      name: "materials-demo",
    },
    {
      // Logged-out demo for Corrección de Tests: log in to try the real
      // version, or "know more" (the service description).
      //
      // OJO al renombrar: este nombre está publicado fuera de la app. El
      // `DEMO_ROUTE` de InviteFriendsView.vue arma los links de invitación como
      // `/utopie/#/test-correction-demo?invita=<token>`, y esos links ya salieron
      // por WhatsApp — viven en conversaciones que no controlamos y no se pueden
      // corregir después.
      //
      // Se rompe en silencio, y por partida doble. El catch-all `{ path: "*" }`
      // del final atrapa cualquier ruta desconocida y muestra la LandingPage:
      // no hay 404, no hay página en blanco, no hay nada que se vea mal. El
      // invitado aterriza en la portada genérica en vez de la demo de tests a la
      // que lo invitaron, y nadie se entera.
      //
      // El referido igual se cobra —InvitationBanner vive en el layout, no en la
      // ruta, así que monta también sobre el catch-all—, pero `$route.name` queda
      // en undefined, el servicio se manda vacío y `referral_rewards` cae a su
      // default `planifications`: la tarjeta le promete al invitado los usos del
      // servicio equivocado.
      //
      // Si hay que renombrarla, hay que mover `DEMO_ROUTE` en el mismo commit y
      // dejar esta ruta vieja como alias, no borrarla.
      path: "/test-correction-demo",
      component: TestCorrectionDemo,
      name: "test-correction-demo",
    },
    {
      // Logged-out demo for the Sistema PIE platform: a hub to know more about
      // each service, reinforcing unlimited uses, with a login CTA.
      path: "/pie-demo",
      component: PieDemo,
      name: "pie-demo",
    },
    {
      path: "/services-details",
      component: ProductDetails,
      name: "services-details",
    },
    {
      // El texto legal vive una sola vez: en /terminos/ y /privacidad/, que
      // sirve Django (backend/marketing/pages.py). Terms.vue tenia una copia
      // completa, y dos copias de un texto legal se separan sin que nadie se
      // entere — la que Google indexa deja de ser la que la persona leyo.
      //
      // La ruta se queda como redireccion y no se borra: estuvo enlazada desde
      // el sidebar y puede vivir en un marcador o en un correo viejo.
      // `window.location` y no `redirect:` del router, porque el destino no es
      // una ruta de este SPA.
      path: "/terms",
      name: "terms",
      component: { render: (h) => h() },
      beforeEnter() {
        window.location.replace("/terminos/");
      },
    },
    {
      path: "/buy_product/:service",
      component: BuyProduct,
      name: "buy-product",
      meta: { layout: "marketplace" },
    },
    {
      path: "/profile",
      component: PersonalData,
      name: "profile",
      meta: { layout: "profile" },
    },
    {
      path: "/marketplace",
      component: Marketplace,
      name: "marketplace",
      meta: { layout: "marketplace" },
    },
    {
      path: "/profile/notifications",
      component: ProfileNotifications,
      name: "profile_notifications",
      meta: { layout: "profile" },
    },
    {
      path: "/profile/missions",
      component: ProfileMissions,
      name: "profile_missions",
      meta: { layout: "profile" },
    },
    {
      path: "/profile/tests",
      component: ProfileTests,
      name: "profile_tests",
      meta: { layout: "profile" },
    },
    {
      path: "/profile/points",
      component: ProfilePoints,
      name: "profile_points",
      meta: { layout: "profile" },
    },
    {
      path: "/profile/delete",
      component: ProfileDelete,
      name: "profile_delete",
      meta: { layout: "profile" },
    },
    { path: "/post/:id", component: PostComponent, name: "post" },
    { path: "/design", name: "design", meta: { layout: "design" } },
    {
      path: "/new_planification",
      component: NewPlanification,
      name: "new_planification",
      meta: { layout: "no_side_profile" },
    },
    {
      path: "/invitation/:uid",
      component: InvitationRegister,
      name: "invitation_register",
      meta: { layout: "no_side_profile" },
    },
    {
      path: "/agregar-cambiar-usuarios",
      name: "agregar-cambiar-usuarios",
      meta: { layout: "fullscreen" },
      component: AddOrChangePasswordAdmin,
    },
    {
      path: "/uso-servicios",
      name: "uso-servicios",
      meta: { layout: "fullscreen" },
      component: ServicesUsageAdmin,
    },
    {
      path: "/crear-mision",
      name: "crear-mision",
      meta: { layout: "fullscreen" },
      component: MissionCreateAdmin,
    },
    {
      path: "/crear-tickets",
      name: "crear-tickets",
      meta: { layout: "fullscreen" },
      component: GoldenTicketsAdmin,
    },
    {
      path: "/completar-mision",
      name: "completar-mision",
      meta: { layout: "fullscreen" },
      component: MissionCompleteAdmin,
    },
    {
      path: "/media",
      component: Media,
      name: "media",
      meta: { layout: "no_side_profile" },
    },
    {
      path: "/fudei/:id",
      name: "fudei",
      component: Fudei,
      meta: { layout: "fullscreen" },
    },
    ...institucionalRoutes,
    { path: "*", component: LandingPage, meta: { landing: true } },
  ],
});
